<label class="checkbox" [ngClass]="{ 'checkbox--error': error, 'checkbox--disabled': disabled }">
  <input class="checkbox__input" [type]="type" [attr.name]="name" [required]="required" [checked]="active" [disabled]="disabled" (change)="change()" (focus)="focus()" />
  <div class="checkbox__main checkbox__main--font-size-{{ fontSize }}">
    <span class="checkbox__check"><app-icon [icon]="'checkbox'" [width]="14"></app-icon></span>
    <span>
      @if (href) {
        <a class="checkbox__link" [href]="href" (click)="linkClick($event)">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </a>
      } @else {
        <ng-container *ngTemplateOutlet="content"></ng-container>
      }
      @if (required) {
        <span class="checkbox__required">&nbsp;*</span>
      }
    </span>
  </div>
  @if (error) {
    <app-input-error>{{ errorMessage }}</app-input-error>
  }
</label>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
